import React from 'react';
import './ListMapToggle.scss';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { KitIcons } from '@repo/apg-ui';

interface Props {
  mapView: boolean;
  setMapView: any;
}

export const ListMapToggle = ({ mapView, setMapView }: Props) => {
  return (
    <div className='list-view-toggle d-block'>
      <div className='view-toggle d-flex border border-radius-4 align-items-center'>
        <div
          className={classNames('cursor-pointer border-end px-4 py-3 font-16 font-bold', {
            'text-dark bg-grey-light svg-stroke-grey': !mapView,
            'text-red bg-transparent svg-stroke-red': mapView,
          })}
          onClick={() => {
            setMapView(false);
          }}
        >
          <KitIcons.ListIcon />
          <span className='ms-2'>
            <FormattedMessage id='ec.journey02.step06.list' defaultMessage='Liste' />
          </span>
        </div>
        <div
          className={classNames('cursor-pointer px-4 py-3 font-16 font-bold align-items-center', {
            'text-dark bg-grey-light svg-stroke-grey': mapView,
            'text-red bg-transparent svg-stroke-red': !mapView,
          })}
          onClick={() => {
            setMapView(true);
          }}
        >
          <KitIcons.MapIcon />
          <span className='ms-2'>
            <FormattedMessage id='ec.journey02.step06.map' defaultMessage='Karte' />
          </span>
        </div>
      </div>
    </div>
  );
};
